import { render } from "./upsertCitizenshipDocumentDialog.vue?vue&type=template&id=0efe78a3"
import script from "./upsertCitizenshipDocumentDialog.vue?vue&type=script&lang=js"
export * from "./upsertCitizenshipDocumentDialog.vue?vue&type=script&lang=js"

import "./upsertCitizenshipDocumentDialog.vue?vue&type=style&index=0&id=0efe78a3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__